// 初始化底部Icon
const iconsId = ['home', 'mine', 'cart', 'category', 'coupon', 'live'];
const DEF_FOOTER_ICONS = [];
['0', '1', '2'].forEach(prefix => {
  iconsId.forEach(id => {
    DEF_FOOTER_ICONS.push({
      id: `${id}-${prefix}`,
    });
    DEF_FOOTER_ICONS.push({
      id: `${id}-${prefix}-active`,
    });
  });
});

export default {
  fromGoodsDecoration: 'goodsDecoration',
  BANNER_STYLE_TYPE_LIST: [1, 2, 3, 4, 5, 7],
  DOTS_STYLE_TYPE_LIST: [1, 2, 3, 4, 5],
  SHOP_NAV_STYLE_TYPE_LIST: [1, 2],
  IMG_NAV_STYLE_TYPE_LIST: [1, 2, 3],
  TITLE_BAR_STYLE_TYPE_LIST: [1, 2, 3],
  SEARCH_BAR_STYLE_TYPE_LIST: [1],
  CATEGORY_STYLE_TYPE_LIST: [1, 2, 3],
  GOODS_STYLE_TYPE_LIST: [1, 2, 3],
  // 0未上线，1上线，2已下线
  SPECAIL_PAGE_STATUS: {
    notOnlineYet: 0,
    online: 1,
    offline: 2,
  },
  DEF_LINK_ITEM: {
    systemLink: '',
    h5Link: '',
    miniLink: '',
    otherMiniLink: {
      appId: '',
      path: '',
      extraData: {
        backPath: '',
      },
    },
    otherMiniAlipayLink: {
      appId: '',
      path: '',
      extraData: {
        backPath: '',
      },
    },
    otherType: 'weapp', // system custom
    linkType: 'system', // system custom
    customType: 'h5', // h5, mini otherMini
  },
  DEF_GOODS_GROUP_ITEM: {
    id: '',
    name: '',
    customName: '',
    limitType: 'num', // all
    limitNum: 6,
    userLinkUrl: null,
  },
  DEF_SHOP_ITEM: {
    id: '',
    sellerId: '',
    storeName: '',
    storeNavigationId: '',
    status: 0,
    template: 'blank',
    background: '#f8f8f8',
    content: '',
    modifyTime: 0,
  },
  DEF_FOOTER_NAV_ITEM: {
    id: '',
    sellerId: '',
    storeName: '',
    navigationName: '',
    navigationType: 'app',
    content: '',
  },
  DEF_HOT_WORDS: {
    id: '',
    sellerId: '',
    keyWordName: '',
    keyWordType: 1,
    styleFlag: 0,
    linkUrl: '',
    sort: 0,
  },
  DEF_FOOTER_NAV: ['mine', 'home', 'cart'],
  DEF_FOOTER_ICONS, // 根据文件夹生成
  KEY_WORD_TYPE_LIST: [
    {
      label: '关键词搜索商品',
      value: 1,
    },
    {
      label: '链接页面',
      value: 2,
    },
  ],
  FUNC_TABS_LIST: [
    {
      label: '功能页面',
      value: 'function',
    },
    {
      label: '商品分组',
      value: 'goodsGroup',
    },
    {
      label: '商品详情',
      value: 'goodsDetail',
    },
    {
      label: '专题页',
      value: 'special',
    },
    {
      label: '领券活动页',
      value: 'coupon',
    },
    {
      label: '营销活动页',
      value: 'marketing',
    },
  ],
  COUPON_EFFECTIVE_CHANNEL : [
    {
      label: '小程序',
      value: 'online',
    },
    {
      label: '芥舟',
      value: 'jiezhou',
    },
  ],
};
